import React, { useState, useRef, useEffect, useContext } from 'react';
import { ModalProvider, useModal,closeModal } from "../context/ModalContext";
import { useAuth } from "../context/useAuth"
//import {useMessages } from "../context/MessagesContext"
import { useMessages } from "../context/useMessages";


const INTENTS = {
  check_balance: { icon: '💰', label: 'Balance' },
  money_transfer: { icon: '💸', label: 'Transfer' },
  start_loan: { icon: '🏦', label: 'Loan' },
  login: { icon: '🔒', label: 'Login' },
  create_customer: { icon: '👤', label: 'Profile' },
  get_customer_info: { icon: '👤', label: 'Profile' },
  fallback: { icon: '💬', label: 'Info' },
};



const handleSignupSubmit = (formPayload) => {
  console.log("AIBanking.handleSignupSubmit:", formPayload);
}

const handleCustomerSubmit = (formPayload) => {
  console.log("AIBanking.handleCustomerSubmit:", formPayload);
  
};

function SigninButton({ message }) {
  const { openModal,closeModal } = useModal();
  const { addMessage } = useMessages(); 

  
  const handleSubmit = (formPayload) => {
    console.log("SigninButton.handleSubmit:", formPayload);
    addMessage({
      role: 'ai',
      text: `✅ Welcome! You are now signed in.`,
      }); 
    
  };
  return (
    <div>
      <p style={{ margin: '0 0 12px 0' }}>{message.text}</p>
      <button 
        onClick={()=>openModal('SIGNIN', {onSuccess: handleSubmit})}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 16px',
          fontSize: '13px',
          fontWeight: 500,
          borderRadius: '8px',
          background: 'rgba(255,255,255,0.12)',
          border: '0.5px solid rgba(255,255,255,0.25)',
          color: 'inherit',
          cursor: 'pointer',
        }}
      >
        🔒 Sign in
      </button>
    </div>
  );
}

function SignupButton({ message }) {
  const { openModal } = useModal();
  const { addMessage } = useMessages();
  
  const handleSubmit = (formPayload) => {
    console.log("SignupButton.handleSubmit:", formPayload);
    addMessage({
      role: 'ai',
      text: `✅ User created. You can sign in`,
      });
  };
  return (
    <div>
      <p style={{ margin: '0 0 12px 0' }}>{message.text}</p>
      <button
        //onClick={()=>openModal('SIGNUP',{handleSubmit})}
        onClick={()=>openModal('SIGNUP',{onSuccess: handleSubmit})}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 16px',
          fontSize: '13px',
          fontWeight: 500,
          borderRadius: '8px',
          background: 'rgba(255,255,255,0.12)',
          border: '0.5px solid rgba(255,255,255,0.25)',
          color: 'inherit',
          cursor: 'pointer',
        }}
      >
        🔒 Sign up
      </button>
    </div>
  );
}


function CustomerButton({ message }) {
  const { openModal,closeModal } = useModal();
  const { addMessage } = useMessages(); 

  
  const handleSubmit = (payload) => {
    console.log("CustomerButton.handleSubmit:", payload);
    addMessage({
      role: 'ai',
      text: `Customer created. ${payload}` 
      }); 
    
  };
  return (
    <div>
      <p style={{ margin: '0 0 12px 0' }}>{message.text}</p>
      <div>
          <button
            onClick={()=>openModal("CUSTOMER", {onSuccess: handleSubmit})}
            style={{
              display: 'inline-flex',
              alignItems: 'center', 
              gap: '6px',
              padding: '8px 16px',
              fontSize: '13px',
              fontWeight: 500,
              borderRadius: '8px',
              background: 'rgba(255,255,255,0.12)',
              border: '0.5px solid rgba(255,255,255,0.25)',
              color: 'inherit',
              cursor: 'pointer',
            }}
          >
            👤➕ Create Customer
          </button>
          
        </div>
      </div>
  );
};



function AIResponse({ message }) {
  const { openModal } = useModal();
  const [submitModalOpen, setSubmitModalOpen] = useState(false);
  const authorized = useAuth((state) => state.authorized);
  const username = useAuth((state) => state.user);
  

  //const createCustomerRef = useRef(null);
  if ((message.intent === 'login') || (!authorized && message.must_authorize)) return (
    <SigninButton message={message}  />
  );

  if (message.intent === 'signup')  return (
    <SignupButton message={message}  />
  );


  if (message.intent === 'balance_display') return (
    <div>
      <p style={{ margin: '0 0 10px 0' }}>{message.text}</p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        {(message.data?.accounts || []).map(acc => (
          <div key={acc.account_id} style={styles.card}>
            <p style={styles.cardLabel}>{acc.type}</p>
            <p style={styles.cardValue}>€{acc.balance.toLocaleString()}</p>
            <p style={{ fontSize: '10px', opacity: 0.5, margin: 0 }}>{acc.account_id}</p>
          </div>
        ))}
      </div>
      {message.data?.total_balance && (
        <p style={{ fontSize: '12px', opacity: 0.6, marginTop: '8px', marginBottom: 0 }}>
          Total: <strong>€{message.data?.total_balance?.toLocaleString()}</strong>
        </p>
      )}
    </div>
  );

  if (message.intent in ['transfer_confirmation', 'money_transfer']) return (
    <div>
      <p style={{ margin: '0 0 10px 0' }}>{message.text}</p>
      <div style={styles.infoBox}>
        <p style={styles.infoRow}>Amount: <strong>€{message.data?.amount}</strong></p>
        <p style={styles.infoRow}>To: <strong>{message.data?.recipient}</strong></p>
        <p style={styles.infoRow}>From: <strong>{message.data?.from_account}</strong></p>
        <p style={styles.infoRow}>Arrival: <strong>{message.data?.estimated_arrival?.slice(0, 10)}</strong></p>
        <p style={{ ...styles.infoRow, marginBottom: 0 }}>
          Status: <strong style={{ color: '#86efac' }}>{data.status}</strong>
        </p>
      </div>
    </div>
  );

  if (message.intent === 'loan_wizard') return (
    <div>
      <p style={{ margin: '0 0 10px 0' }}>{message.text}</p>
      {(message.data?.products || []).map(p => (
        <div key={p.type} style={{ ...styles.infoBox, marginBottom: '8px' }}>
          <p style={{ fontWeight: 600, margin: '0 0 6px 0', fontSize: '13px' }}>{p.type}</p>
          <p style={styles.infoRow}>Rate: <strong>{p.interest_rate}%</strong></p>
          <p style={styles.infoRow}>Up to: <strong>€{p.max_amount?.toLocaleString()}</strong></p>
          <p style={{ ...styles.infoRow, marginBottom: 0 }}>
            Terms: <strong>{p.term_months?.join(', ')} months</strong>
          </p>
        </div>
      ))}
      {message.data?.credit_score && (
        <p style={{ fontSize: '12px', opacity: 0.6, marginTop: '6px', marginBottom: 0 }}>
          Credit score: <strong>{message.data?.credit_score}</strong>
        </p>
      )}
    </div>
  );

  if (message.intent === 'user_card') return (
    <div>
      <p style={{ margin: '0 0 10px 0' }}>{JSON.stringify(message.data, null, 2)}</p>
      <div style={styles.infoBox}>
        <p style={styles.infoRow}>Name: <strong>{message.data?.fullname}</strong></p>
        <p style={styles.infoRow}>Email: <strong>{message.data?.email}</strong></p>
        <p style={styles.infoRow}>Phone: <strong>{message.data?.phone}</strong></p>
        <p style={styles.infoRow}>Tier: <strong>{message.data?.tier}</strong></p>
        <p style={styles.infoRow}>Member since: <strong>{message.data?.since}</strong></p>
        {message.data?.address && (
          <p style={{ ...styles.infoRow, marginBottom: 0 }}>
            Address: <strong>{message.data?.address?.street}, {message.data?.address?.city}</strong>
          </p>
        )}
      </div>
    </div>

  );

  if (message.intent === 'create_customer') return (
    <div>
      <p style={{ margin: '0 0 10px 0' }}>{message.text}</p>
      <div style={styles.infoBox}>
        <p style={styles.infoRow}>Name: <strong>{message.data?.fullname || " "}</strong></p>
        <p style={styles.infoRow}>Email: <strong>{message.data?.email || " "}</strong></p>
        <p style={styles.infoRow}>Phone: <strong>{message.data?.phone || " "}</strong></p>
        {message.data?.address ? (
          <p style={{ ...styles.infoRow, marginBottom: 0 }}>
            Address: <strong>{message.data?.address?.street || " "}, {mmessage?.data?.address?.city || " "}</strong>
          </p>
        ): (
           <p style={{ ...styles.infoRow, marginBottom: 0 }}>Address: " " </p>
        )}
        
        <CustomerButton message={message} />
      </div>
    </div>
  );
  return (
    <div>
      {Array.isArray(message?.data) && message.data.length > 0 ? (
        <p style={{ margin: '0 0 10px 0', whiteSpace: 'pre-wrap' }}>
          {JSON.stringify(message.data, null, 2)}
        </p>
      ) : null}
      <div style={styles.infoBox}>
        <p style={styles.infoRow}>intent:<strong>{message.intent}</strong></p>
        <p style={styles.infoRow}><strong>{message.text}</strong></p>
        {message?.data && Array.isArray(message.data) && (
          <ul style={{ paddingLeft: '20px', margin: '5px 0' }}>
            {message.data.map((d, i) => (
              <li key={i} style={styles.infoRow}>
                <strong>{d}</strong>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

function Message({ msg }) {
  const isUser = msg.role === 'user';
  
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} w-full`}>
      <div className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-relaxed ${isUser
        ? 'bg-accent text-ink rounded-br-sm'
        : 'bg-ink/10 border border-ink/10 text-ink rounded-bl-sm'
        }`}>
        {/* For login_form the AIResponse owns the message text */}
        {(!msg.intent || msg.intent === 'text' || msg.intent === 'fallback') ? (
          <>
            <span style={{ whiteSpace: 'pre-wrap' }}>{typeof msg?.text === 'object' ? JSON.stringify(msg.text) : msg?.text}</span>
          </>
        ) : (
          <>
            <AIResponse message={msg}/>
          </>
        )}

      </div>
    </div>
  );
}

export default function AIBanking() {
  //[messages, setMessages] = useState();
  
  //const { messages, addMessage, clearMessages,ini } = useMessages();
  const addMessage = useMessages((state) => state.addMessage);
  const messages = useMessages((state) => state.messages);
  const authorized = useAuth((state) => state.authorized);
  const username = useAuth((state) => state.username);
  //clearMessages();
  const initMessages = useMessages((state) => state.initMessages);
  useEffect(() => {
  initMessages({
      role: 'ai',
      text: 'Hello! I\'m your AI banking assistant. Try asking me to check your balance, make a transfer, or apply for a loan.',
      data: {},
      intent: ''
    });
  }, [initMessages]); 
  {/*role: 'ai', 
    text: "I'll help you ... information:", 
    component: 'create_customer', 
    data: {…}, 
    intent: 'create_customer', …*/}
 
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const bottomRef = useRef(null);

  //const [openModal, setOpenModal] = useState('')
  //const openCustomerModal = () => setOpenModal("CustomerModal");
  
  
  //console.log("React:", React);
  //console.log("useContext:", React.useContext);


  /* useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);
 */
  const suggestions = ['balance', 'transfer', 'loan', 'customer profile', 'login', 'help'];

  async function sendPrompt(text) {
    const prompt = text || input.trim();
    if (!prompt) return;

    addMessage({ role: 'user', text: prompt });
    setInput('');
    setLoading(true);

    try {
      const res = await fetch('/aip/aibanking', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: prompt }),
      });

      if (!res.ok) throw new Error(`Server error: ${res.status}`);
      const data = await res.json();

      addMessage( {
        role: 'ai',
        text: data?.message || '',
        data: data?.data || {},
        intent: data?.intent || '',
      });

    } catch (err) {
      addMessage({
        role: 'ai',
        text: '⚠️ Could not reach the AI service. Make sure the backend is running.',
      });
    } finally {
      setLoading(false);
    }
  }

  function handleKey(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendPrompt();
    }
  }
  
  
  function handleMessage(msg) {
    addMessage(msg);
  }
  


  return (
    <section id="banking" className="py-24 px-6 max-w-5xl mx-auto">
      <div className="max-w-5xl">
        <p className="text-accent font-body text-ink tracking-[0.2em] uppercase mb-4">Live ...</p>
        <div class="flex justify-end">
          <div id="auth-badge"
            class="text-xs text-red-400 px-3 py-1 bg-red-950/50 border border-red-900 rounded-full font-medium">
            {authorized ? (username + " 🟢 Authorized") : "🔴 Unauthorized"}
          </div>
        </div>
        <h2 className="font-display text-4xl text-ink mb-4">AI Banking Assistant</h2>
        <p className="font-body text-ink/50 text-ink mb-10 max-w-lg">
          Running on llama-3.1 locally on a Raspberry Pi 4 — intent extraction via REST.
        </p>

        <div className="border border-cream/10 rounded-2xl overflow-hidden">

          {/* Chat header */}
          <div className="bg-cream/5 border-b border-cream/10 px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-accent animate-pulse" />
              <span className="font-body text-ink text-ink">Bank Assistant</span>
            </div>
            <div className="flex gap-1.5">
              {['bg-red-500', 'bg-yellow-500', 'bg-green-500'].map(c => (
                <div key={c} className={`w-2.5 h-2.5 rounded-full ${c} opacity-60`} />
              ))}
            </div>
          </div>

          {/* Messages */}
          <div className="h-70 overflow-y-auto p-6 space-y-4 bg-cream/[0.02]">
            {messages.map((msg, i) => (
              <Message key={i} msg={msg} //onMessage={handleMessage}
                                         //authorized={authorized}
              />
            ))}
            {loading && (
              <div className="flex justify-start">
                <div className="bg-ink/10 border border-ink/10 rounded-2xl px-4 py-3 text-ink text-ink/40 animate-pulse">
                  Thinking...
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          {/* Suggestions */}
          <div className="px-6 py-3 border-t border-cream/10 flex gap-2 flex-wrap bg-cream/[0.02]">
            {suggestions.map(s => (
              <button
                key={s}
                onClick={() => sendPrompt(s)}
                disabled={loading}
                className="text-xs font-body px-3 py-1.5 border border-accent/30 text-accent hover:bg-accent hover:text-ink transition-all duration-200 disabled:opacity-40"
              >
                {s}
              </button>
            ))}
          </div>

          {/* Input */}
          <div className="px-6 py-4 border-t border-cream/10 flex gap-3 bg-cream/[0.02]">
            <textarea
              rows={1}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKey}
              placeholder="Ask about your account..."
              disabled={loading}
              className="flex-1 bg-transparent border border-ink/20 focus:border-accent rounded-lg px-4 py-2.5 text-sm text-ink placeholder-cream/30 focus:outline-none resize-none transition-colors"
            />
            <button
              onClick={() => sendPrompt()}
              disabled={loading || !input.trim()}
              className="px-5 py-2.5 bg-accent text-ink text-sm font-body hover:bg-cream transition-colors disabled:opacity-40">
              Send
            </button>
          </div>

        </div>

        {/* Intent legend */}
        <div className="mt-6 flex flex-wrap gap-4">
          {Object.entries(INTENTS).map(([key, { icon, label }]) => (
            <div key={key} className="flex items-center gap-2 text-xs font-body text-ink/40">
              <span>{icon}</span>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>

    </section>
  );

}


const styles = {
  card: {
    background: 'rgba(255,255,255,0.08)',
    borderRadius: '8px',
    padding: '10px',
  },
  cardLabel: {
    fontSize: '10px',
    opacity: 0.5,
    margin: '0 0 4px 0',
    textTransform: 'capitalize',
  },
  cardValue: {
    fontSize: '16px',
    fontWeight: 600,
    margin: '0 0 2px 0',
  },
  infoBox: {
    background: 'rgba(255,255,255,0.08)',
    borderRadius: '8px',
    padding: '10px 12px',
  },
  infoRow: {
    fontSize: '12px',
    margin: '0 0 4px 0',
  },
};